import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationReactivateAssetFailedDto extends IGetNotification {
    notificationType: NotificationType.reactivateAssetFailed
    assetId: Guid  // ID of the disposed asset where reactivation was attempted
    lmid: string
    articleDescription?: string | null
    errorMessage?: string | null
}

export default class NotificationReactivateAssetFailed extends Notification {
    asset: NotificationAsset
    errorMessage?: string

    constructor(dto: IGetNotificationReactivateAssetFailedDto) {
        super(dto)
        this.asset = new NotificationAsset({
            assetId: dto.assetId,
            lmid: dto.lmid,
            articleDescription: dto.articleDescription ?? undefined
        })
        this.errorMessage = dto.errorMessage ?? undefined
    }
}
